
$.widget 'custom.message_writer',
    options:
        infoClass: 'alert alert-info'
        warnClass: 'alert alert-warn'
        errorClass: 'alert alert-error'
        successClass: 'alert alert-success'
        generalClass: 'alert'
        fadeInTime: 400
        fadeOutTime: 400
        hideTime: 3500
        autoHide: true

    _create: () ->
        @element.hide()
        @setInitialClass()


    _setOption: (key, value) ->
        undefined

    destroy: () ->
        undefined

    setInitialClass: () ->
        @initialClass = @element.attr('class')


    # Will determine the msg type automatically from the  json response
    write: (json, do_hide, callback = null) ->
        type    = json.status.type
        msg     = json.status.msg

        if not do_hide?
            @[type] msg, false, callback
        else
            @[type] msg, do_hide, callback


    info: (msg, do_hide = false, callback = null) ->
        @_setMsg 'info', msg, callback
        @hide() if do_hide

    warn: (msg, do_hide = false, callback = null) ->
        @_setMsg 'warn', msg, callback
        @hide() if do_hide

    success: (msg, do_hide = false, callback = null) ->
        @_setMsg 'success', msg, callback
        @hide() if do_hide

    error: (msg, do_hide = false, callback = null) ->
        @_setMsg 'error', msg, callback
        @hide() if do_hide

    general: (msg, do_hide = false, callback = null) ->
        @_setMsg 'general', msg, callback
        @hide() if do_hide


    _setMsg: (type, msg, cb) ->
        @element.html msg
        css = @options["#{type}Class"]

        @element.attr 'class', "#{@initialClass} #{css}"

        @show(cb)

    hide: (timeout) ->

        timeout ?= @options.hideTime

        setTimeout () =>
            if not @element.is(':visible')
                return
            @element.fadeOut @options.fadeOutTime
        , timeout


    show: (cb) ->
        @element.fadeIn @options.fadeInTime, cb


    clear: () ->
        @element.stop true
        @element.fadeOut @options.fadeOutTime
